import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Purchasing: purchase orders to vendors, receiving and simple stock. Owned by the purchasing module (D11).
export const routes: RouteObject[] = [
  { path: 'purchasing', lazy: page(() => import('./orders-page'), (m) => m.PurchaseOrdersPage) },
  { path: 'purchasing/orders/:poId', lazy: page(() => import('./order-detail'), (m) => m.PurchaseOrderPage) },
  { path: 'purchasing/stock', lazy: page(() => import('./stock-page'), (m) => m.StockPage) },
];

export const orgRoutes: RouteObject[] = [];
